import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import React from "react";
import { getGenderName } from "utilities/genderUtils";

interface Props {
  value: server.dto.Genders;
  onChange: (value: server.dto.Genders) => void;
}

export const GenderRadio = (props: Props) => {
  return <RadioGroup
    orientation="vertical"
    options={[
      { label: getGenderName("unspecified"), value: "unspecified" satisfies server.dto.Genders },
      { label: getGenderName("other"), value: "other" satisfies server.dto.Genders },
      { label: getGenderName("female"), value: "female" satisfies server.dto.Genders },
      { label: getGenderName("male"), value: "male" satisfies server.dto.Genders }
    ]}
    value={props.value}
    onChange={props.onChange}
  />
}